
(function() {
  var result = { translations: { "sl": { "i18n": { "duration": { "seconds": "{{ seconds }} sekund", "minutes": "{{ minutes }} min", "hours": "{{ hours }} ur", "hoursAndMinutes": "{{ hours }} ur {{ minutes }} minut", "days": "{{ days }} dni", "shortForm": { "seconds": "{{ seconds }} sekund", "minutes": "{{ minutes }} minut", "hours": "{{ hours }} ur", "days": "{{ days }} dni", "hoursAndMinutes": "{{ hours }} ur {{ minutes }} minut" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, zun. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "sl": "static-7.1344"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1344",
    "ar-eg": "static-7.1344",
    "bg": "static-7.1344",
    "bn": "static-7.1344",
    "ca-es": "static-7.1344",
    "cs": "static-7.1344",
    "da": "static-7.1344",
    "de": "static-7.1344",
    "el": "static-7.1344",
    "en-gb": "static-7.1344",
    "en": "static-7.1344",
    "es-mx": "static-7.1344",
    "es": "static-7.1344",
    "et": "static-7.1344",
    "fi": "static-7.1344",
    "fr-ca": "static-7.1344",
    "fr": "static-7.1344",
    "he-il": "static-7.1344",
    "hi": "static-7.1344",
    "hr": "static-7.1344",
    "hu": "static-7.1344",
    "id": "static-7.1344",
    "it": "static-7.1344",
    "ja": "static-7.1344",
    "ko": "static-7.1344",
    "lt": "static-7.1344",
    "ms": "static-7.1344",
    "nl": "static-7.1344",
    "no": "static-7.1344",
    "pl": "static-7.1344",
    "pt-br": "static-7.1344",
    "pt-pt": "static-7.1344",
    "ro": "static-7.1344",
    "ru": "static-7.1344",
    "sk": "static-7.1344",
    "sl": "static-7.1344",
    "sv": "static-7.1344",
    "th": "static-7.1344",
    "tl": "static-7.1344",
    "tr": "static-7.1344",
    "uk": "static-7.1344",
    "vi": "static-7.1344",
    "x-pseudo": "static-7.1344",
    "zh-cn": "static-7.1344",
    "zh-hk": "static-7.1344",
    "zh-tw": "static-7.1344"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:sl', {version: 'static-7.1344'}); }
})();


